import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Jello from "react-reveal/Jello";
import axios from "axios";

function RecuperaPassword() {
  let history = useHistory();

  const initialValues = {
    email: "",
  };

  const onSubmit = (data) => {
    axios
      .put(
        "https://website-8bit-motors.herokuapp.com/account/recuperaPassword",
        data
      )
      .then((response) => {
        if (response.data.error) {
          alert(response.data.error);
        } else {
          alert("password cambiata");
          console.log(response.data);
          history.push("/account/login");
        }
      });
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Per continuare devi compilare questo campo!"),
  });

  return (
    <Container fluid className="app">
      <Jello>
        {/* SEZIONE BANNER */}
        <Container
          fluid
          className="head-banner text-white text-center"
          id="banner_accesso"
        >
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Jello>

      {/* FORM REGISTRAZIONE */}
      <Container className="form_registrazione text-center">
        <h2 className="mt-3">Recupera Password</h2>
        <h3>Inserisci la tua email per ottenere una password provvisoria</h3>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          <Form>
            <Row className="justify-content-md-center mt-3">
              <Col className="col-4">
                <label className="mb-1 mt-3  form_registrazione" for="email">
                  Email
                </label>
                <ErrorMessage name="email" component="h6" />
                <Field
                  type="email"
                  className="form-control input_registrazione"
                  name="email"
                  placeholder="Inserisci email"
                />
              </Col>
            </Row>

            {/* CONFERMA */}
            <Button variant="success" className="mt-3" type="submit">
              Recupera Password
            </Button>
          </Form>
        </Formik>
        <br />
        <br />
        <br />
        <br />
        <br />
      </Container>
    </Container>
  );
}

export default RecuperaPassword;
